import React, { PropsWithChildren, useContext } from 'react'
import { StoresContext } from '@App/contexts'
import { ICONS } from '@Const/common'
import './index.scss'
import clsx from 'clsx'
import { observer } from 'mobx-react'

interface SidebarProps {}

const Sidebar = (props: PropsWithChildren<SidebarProps>) => {
    const { rightsholderStore, rightsholderSearchStore, songwriterStore, songwriterSearchStore } =
        useContext(StoresContext)
    const memberSummary = rightsholderStore.optionalMemberSummary
    const songwriterSummary = songwriterStore.optionalSongwriterSummary
    const rightsholderCount = rightsholderSearchStore.rightsholderCount
    const songwriterCount = songwriterSearchStore.songwriterCount

    const sidebarName = memberSummary?.name ?? songwriterSummary?.name
    const sidebarCount = rightsholderCount ?? songwriterCount

    return (
        <nav className="sidebar-navigation">
            {(memberSummary || songwriterSummary) && (
                <div className={clsx('sidebar-head', sidebarCount > 1 && 'hide-header-mobile')}>
                    <img src={ICONS.account} alt="Accounts" />
                    <h5 title={sidebarName}>{sidebarName}</h5>
                </div>
            )}
            <div className="nav-wrapper">{props.children}</div>
        </nav>
    )
}

export default observer(Sidebar)
